<template>
    <div>
        <MercenaryScheduleDetail :schedule-detail-idx="schedule_idx" :close-schedule-detail="closeAction" :isOpenScheduleDetail="isOpen" :is-back-press-apply="true"/>
    </div>
</template>

<script>
    import MercenaryScheduleDetail from "./MercenaryScheduleDetail";
    export default {
        name: "MercenaryScheduleDetailPopup",
        props : {
            schedule_idx : {
                type: [Number, String],
                default: -1
            }
        },
        components: {MercenaryScheduleDetail},
        data(){
            return {
                isOpen : false,
            }
        },
        mounted(){
            setTimeout(() => {
                this.isOpen = true;
            }, 0)
        },
        methods : {
            closeAction() {
                if(this.isOpen) {
                    this.isOpen = false;
                    return;
                }
                setTimeout(() => {
                    this.$GlobalStore.closeLastModal();
                }, 300)
            },
        },
        created() {

        }

    }
</script>

<style scoped>
.pro_modal {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0px;
}

.basic_frame {
    width: calc(100% - 40px);
    background-color: #fff;
    padding: 20px;
    border-radius: 20px;
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translate(-50%, 0);
    transition: 0.5s all;
    z-index: 20;
    /* text-align: center; */
    font-weight: 500;
}

.basic_frame.open {
    top: 50%;
    transform: translate(-50%, -50%);
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
    {
    opacity: 0;
}
</style>